'use strict';

module.exports = {
    SCRIPT: 'jsError',
    AJAX: 'ajaxError',
    RESOURCE: 'resourceError'
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/constant/category.js
// module id = 73
// module chunks = 0